import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_98f4c0a7-37e3-4eee-b45d-3c901b2920ec/artifacts/cpmel363_Purpose%20reclaimed%20coaching.png';

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const links = [
    { to: '/', label: 'Home' },
    { to: '/coaching', label: 'Coaching' },
    { to: '/purchase', label: 'Ebook' },
    { to: '/cards', label: 'Card Sets' },
    { to: '/workshops', label: 'Workshops' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <nav data-testid="navbar" className="bg-white/90 backdrop-blur-md border-b border-stone-100 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Purpose Reclaimed Coaching" className="h-10 w-10 rounded-full object-cover" />
          <span className="font-heading text-xl text-charcoal hover:text-sage transition-colors hidden sm:inline">Purpose Reclaimed</span>
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              className={`text-sm font-medium transition-colors ${
                pathname === l.to ? 'text-sage' : 'text-charcoal-light hover:text-sage'
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-charcoal"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 space-y-3">
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={`block text-sm font-medium py-2 ${
                pathname === l.to ? 'text-sage' : 'text-charcoal-light'
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};
